import React, { useState, useEffect } from 'react'
import { Grid, CircularProgress, Tooltip } from '@material-ui/core'
import * as queryString from 'query-string'
import { changePassword } from '../../../clients/userPool'
import { useRouter } from '../../../auth/useRouter'
import { CustomFullPageWrapper, CustomPaper, PasswordCriteria } from './styles'
import { LoginTitle, StyledButton, StyledTextField } from '../../../theme/Global'
import CompanyLogo from '../../../app/components/companyLogo'
import LoginDialog from '../loginDialog/index'

const getUsername = (search) => {
  const parsedQueryString = queryString.parse(search)
  return parsedQueryString.username || ''
}

const ChangePassword = () => {
  const router = useRouter()
  const [errorMessage, setErrorMessage] = useState('')
  const [attempting, setAttempting] = useState(false)
  const [username, setUsername] = useState('')
  const [usernameLocked, setUsernameLocked] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  useEffect(() => {
    const username = getUsername(router.location.search)
    if (username) {
      setUsername(username)
      setUsernameLocked(true)
    }
  }, [])

  const onSuccess = () => {
    setAttempting(false)
    router.push('/')
  }

  const onFail = (error) => {
    setAttempting(false)
    switch (error.code) {
      case 'NotAuthorizedException':
        setErrorMessage('The email or password you entered is incorrect, please correct your email or password. If you have any questions or need to register please contact your account manager or customer service.')
        break
      case 'InvalidPasswordException':
        setErrorMessage(error.message)
        break
      default:
        setErrorMessage('There was an error changing your password. Please try again, if the problem persists please contact your Account Manager.')
        break
    }
  }

  const onCloseError = () => {
    setErrorMessage('')
  }

  const submit = () => {
    if (!username || !username.trim()) {
      return setErrorMessage('You must provide an email address.')
    }

    if (!oldPassword) {
      return setErrorMessage('You must provide your current password.')
    }

    if (newPassword != confirmPassword) {
      return setErrorMessage('New password and confirmation should match.')
    }

    setAttempting(true)
    changePassword(username, oldPassword, newPassword, onSuccess, onFail)
  }

  return (
    <CustomFullPageWrapper>
      <Grid container justify="center">
        <Grid item xs={12} lg={12}>
          <CustomPaper>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <CompanyLogo size="login" color />
              </Grid>
              <Grid item xs={12}>
                <LoginTitle>Change Password</LoginTitle>
                <LoginDialog {...{ errorText: errorMessage, error: errorMessage !== '', onCloseError }} />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  name="username"
                  fullWidth
                  label="Email Address"
                  disabled={usernameLocked}
                  data-testid="username-input"
                  onChange={(event) => setUsername(event.target.value)}
                  value={username}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  name="oldPassword"
                  fullWidth
                  label="Temporary Password"
                  data-testid="oldpassword-input"
                  onChange={(event) => setOldPassword(event.target.value)}
                  type="password"
                  value={oldPassword}
                />
              </Grid>
              <Grid item xs={12}>
                <Tooltip title={(
                  <PasswordCriteria data-testid="new-password-criteria">
                    <li>- Minimum 8 characters</li>
                    <li>- At least one lower case</li>
                    <li>- At least one upper case</li>
                    <li>- At least one number</li>
                  </PasswordCriteria>
              )}
                >
                  <StyledTextField
                    name="newPassword"
                    fullWidth
                    label="New Password"
                    data-testid="newpassword-input"
                    onChange={(event) => setNewPassword(event.target.value)}
                    type="password"
                    value={newPassword}
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  name="confirmPassword"
                  fullWidth
                  label="Confirm Password"
                  data-testid="confirmpassword-input"
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  type="password"
                  value={confirmPassword}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid item>
                  <StyledButton disabled={attempting} onClick={submit} data-testid="change-button">
                    {attempting ? <CircularProgress size={16} style={{ marginRight: '10px' }} /> : null}
                      Change Password
                  </StyledButton>
                </Grid>
              </Grid>
            </Grid>
          </CustomPaper>
        </Grid>
      </Grid>
    </CustomFullPageWrapper>
  )
}

export default ChangePassword
